export enum Roles {
  SUPER_ADMIN = "super-admin",
  AUCTIONER = "auctioner",
  USER = "user",
}
